import { ValidationErrors } from '@angular/forms'
import { FXSpotType } from '../model/single-transaction/fx-spot-trade/fx-spot.model'
import { TransferOptions } from '../model/single-transaction/security-transfer/transfer-options.model'
import { TransactionTypeEnum } from '../model/transaction-type.model'

export class TransactionConstants {
  static HELIOS_BULK_CASH_ENTRY_SAVE_NOTE_CW_CREATE =
    'Helios Bulk Cash Entry Dialog Create'
  static HELIOS_BULK_TRADE_SAVE_NOTE_CW_CREATE =
    'Helios Bulk Trade Dialog Create'
  static HELIOS_BULK_FX_Forward_SAVE_NOTE_CW_CREATE =
    'Helios Bulk Currency Forward Dialog Create'
  static HELIOS_BULK_FX_TRADE_SAVE_NOTE_CW_CREATE =
    'Helios Bulk Fx Trade Dialog Create'
  static HELIOS_BULK_DIRECT_TRANSFER_SAVE_NOTE_CW_CREATE =
    'Helios Bulk Direct Transfer Dialog Create'
  static HELIOS_BULK_DIRECT_TRANSFER_SAVE_NOTE_CW_EDIT =
    'Helios Bulk Direct Transfer Dialog Edit'
  static HELIOS_BULK_DIRECT_CASH_TRANSFER_SAVE_NOTE_CW_CREATE =
    'Helios Bulk Wire Transfer Dialog Create'
  static HELIOS_BULK_CASH_ENTRY_SAVE_NOTE_CW_EDIT =
    'Helios Bulk Cash Entry Dialog Update'
  static HELIOS_BULK_TRADE_SAVE_NOTE_CW_EDIT = 'Helios Bulk Trade Dialog Update'
  static HELIOS_BULK_FX_FORWARD_SAVE_NOTE_CW_EDIT =
    'Helios Bulk Currency Forward Dialog Update'
  static HELIOS_BULK_FX_TRADE_SAVE_NOTE_CW_EDIT =
    'Helios Bulk Fx Trade Dialog Update'
  static HELIOS_BULK_DIRECT_CASH_TRANSFER_SAVE_NOTE_CW_EDIT =
    'Helios Bulk Wire Transfer Dialog Update'
  static HELIOS_BULK_SECURITY_EXCHANGE_SAVE_NOTE_CW_CREATE =
    'Helios Bulk Security Exchange Dialog Create'
  static HELIOS_BULK_SECURITY_TRANSFER_SAVE_NOTE_CW_EDIT =
    'Helios Bulk Security Transfer Dialog Update'
  static HELIOS_BULK_SECURITY_TRANSFER_SAVE_NOTE_EXTERNAL =
    'Helios Bulk Security Transfer Dialog Enter'
  static HELIOS_BULK_SECURITY_TRANSFER_SAVE_NOTE_CW_CREATE =
    'Helios Bulk Security Transfer Dialog Create'
  static HELIOS_BULK_LOAD_SAVE_NOTE_CW_EDIT = 'Helios Bulk Load Dialog Update'
  static HELIOS_BULK_CASH_ENTRY_SAVE_NOTE_EXTERNAL =
    'Helios Bulk Cash Entry Dialog Enter'
  static HELIOS_BULK_TRADE_SAVE_NOTE_EXTERNAL = 'Helios Bulk Trade Dialog Enter'
  static HELIOS_BULK_FX_FORWARD_SAVE_NOTE_EXTERNAL =
    'Helios Bulk Currency Forward Dialog Enter'
  static HELIOS_BULK_FX_TRADE_SAVE_NOTE_EXTERNAL =
    'Helios Bulk Fx Trade Dialog Enter'
  static HELIOS_BULK_DIRECT_CASH_TRANSFER_SAVE_NOTE_EXTERNAL =
    'Helios Bulk Wire Transfer Dialog Enter'
  static HELIOS_CASH_ENTRY_SAVE_NOTE_CW_CREATE =
    'Helios Cash Entry Dialog Create'
  static HELIOS_TRADE_SAVE_NOTE_CW_CREATE = 'Helios Trade Dialog Create'
  static HELIOS_FX_FORWARD_SAVE_NOTE_CW_CREATE =
    'Helios Currency Forward Dialog Create'
  static HELIOS_FX_TRADE_SAVE_NOTE_CW_CREATE = 'Helios Fx Trade Dialog Create'
  static HELIOS_DIRECT_TRANSFER_SAVE_NOTE_CW_CREATE =
    'Helios Direct Transfer Dialog Create'
  static HELIOS_DIRECT_CASH_TRANSFER_SAVE_NOTE_CW_CREATE =
    'Helios Wire Dialog Create'
  static HELIOS_SECURITY_TRANSFER_SAVE_NOTE_CW_CREATE =
    'Helios Security Transfer Dialog Create'
  static HELIOS_CASH_ENTRY_SAVE_NOTE_CW_EDIT = 'Helios Cash Entry Dialog Update'
  static HELIOS_TRADE_SAVE_NOTE_CW_EDIT = 'Helios Trade Dialog Update'
  static HELIOS_FX_FORWARD_SAVE_NOTE_CW_EDIT =
    'Helios Currency Forward Dialog Update'
  static HELIOS_FX_TRADE_SAVE_NOTE_CW_EDIT = 'Helios Fx Trade Dialog Update'
  static HELIOS_DIRECT_TRANSFER_SAVE_NOTE_CW_EDIT =
    'Helios Direct Transfer Dialog Update'
  static HELIOS_DIRECT_CASH_TRANSFER_SAVE_NOTE_CW_EDIT =
    'Helios Wire Transfer Dialog Update'
  static HELIOS_SECURITY_TRANSFER_SAVE_NOTE_CW_EDIT =
    'Helios Security Transfer Dialog Update'
  static HELIOS_CASH_ENTRY_SAVE_NOTE_EXTERNAL = 'Helios Cash Entry Dialog Enter'
  static HELIOS_TRADE_SAVE_NOTE_EXTERNAL = 'Helios Trade Dialog Enter'
  static HELIOS_FX_FORWARD_SAVE_NOTE_EXTERNAL =
    'Helios Currency Forward Dialog Enter'
  static HELIOS_FX_TRADE_SAVE_NOTE_EXTERNAL = 'Helios Fx Trade Dialog Enter'
  static HELIOS_DIRECT_TRANSFER_SAVE_NOTE_EXTERNAL =
    'Helios Direct Transfer Dialog Enter'
  static HELIOS_DIRECT_CASH_TRANSFER_SAVE_NOTE_EXTERNAL =
    'Helios Wire Transfer Dialog Enter'
  static HELIOS_SECURITY_TRANSFER_SAVE_NOTE_EXTERNAL =
    'Helios Security Transfer Dialog Enter'

  static TRADE_TYPE_ERROR = 'Transaction type must be trade'
  static SAVE_NOTE_EXTERNAL = 'Transaction Model Enter'
  static SAVE_NOTE_CW_CREATE = 'Transaction Model Create'
  static BULK_SAVE_NOTE_CW_EDIT = 'Bulk Transaction Model Update'
  static BULK_SAVE_NOTE_CW_CREATE = 'Bulk Transaction Model Create'
  static BULK_SAVE_NOTE_EXTERNAL = 'Bulk Transaction Model Enter'
  static HELIOS_SAVE_NOTE_CW_DIRECT_TRANSFER_CREATE =
    'Helios Direct Transfer Dialog Create'
  static HELIOS_SAVE_NOTE_CW_DIRECT_TRANSFER_EDIT =
    'Helios Direct Transfer Dialog Update'
  static SAVE_NOTE_CW_EDIT = 'Transaction Model Update'
  static HELIOS_SOURCE_ID = 90
  static DEFAULT_COUNTER_PARTY_ID = 13
  static FX_SPOT_OPTIONS: FXSpotType[] = [
    { label: 'Spot Trade', type: 'FXS', tranType: 'FX_SPOT_TRADE' },
    {
      label: 'Forward Trade',
      type: 'FXF',
      tranType: 'FX_FORWARD_TRADE',
    },
  ]
  static TRANSFER_OPTIONS: TransferOptions[] = [
    { name: TransactionTypeEnum.TRANSFER_IN, tranType: 'TRANSFER_IN' },
    { name: TransactionTypeEnum.TRANSFER_OUT, tranType: 'TRANSFER_OUT' },
    { name: TransactionTypeEnum.EXCHANGE_IN, tranType: 'EXCHANGE_IN' },
    { name: TransactionTypeEnum.EXCHANGE_OUT, tranType: 'EXCHANGE_OUT' },
    { name: TransactionTypeEnum.INITIAL_LOAD, tranType: 'INITIAL_LOAD' },
  ]
  static DEFAULT_NOTE_VALIDATION_ERROR: ValidationErrors = {
    ['transactionNoteValidator']: {
      message: 'Note field must have 3 words minimum',
    },
  }

  static DELETE_BULK_KEYS = ['Delete']
  static TRADE_CALC_COMP_ID = 'trade-calc-price'
  static TRANSFER_PRICE_REQUEST_COMP_ID = 'transfer-price-request-price'
  static BULK_ROWS_DELETE_COMP_ID = 'bulk-rows-delete'
  static SECURITY_WARNING_COMP_ID = 'security-warning-comp-id'
  static CONFIRM_BUTTON_COMP_ID = 'confirm-button-comp-id'
  static BV_MV_BASIS_COMP_ID = 'bv-mv-basis-comp-id'
  static STICKY_DIALOGUES = [
    TransactionConstants.TRADE_CALC_COMP_ID,
    TransactionConstants.SECURITY_WARNING_COMP_ID,
    TransactionConstants.BV_MV_BASIS_COMP_ID,
    TransactionConstants.TRANSFER_PRICE_REQUEST_COMP_ID,
    TransactionConstants.BULK_ROWS_DELETE_COMP_ID,
  ]
  static validityStatusPriority = [
    'invalid',
    'intermediate',
    'warning',
    'valid',
  ]
  static SAVE_TRANSACTION = 'Saving Transaction...'
  static LOAD_TRANSACTION = 'Loading Transaction...'
  static VALIDATE_TRANSACTION = 'Validating Transaction...'
  static LOAD_SECURITY_INFORMATION = 'Loading Security Information...'
  static LOAD_HPL_INFO_BULK = 'Loading HPL Information..'
  static ERROR_LOADING_TRANSACTION = 'Error Loading Transaction...'
  static LOAD_BASIS = 'Loading Basis Details...'
  static ERROR_LOAD_BASIS = 'Error Loading Basis Details...'
  static ERROR_LOAD_SLEEVE_ACCOUNT = 'Error Loading Sleeve Accounts'
  static VALIDATION_ERROR = 'Validation Error'
  static FETCH_DERIVED_FIELDS = 'Fetching Derived Fields'
  static ERROR_FETCH_DERIVED_FIELDS = 'Error Fetching Derived Fields'
  static ERROR_PRICING = 'Error Loading Price Information'
  static LOAD_PRICING = 'Loading Price Information'
  static ERROR_SAVING_TRANSACTION = 'Error Saving Transaction'
  static MIN_FIELD_MESSAGE = 'Please provide minimum required fields'
  static NO_MARKET_VALUE_TRANSFER = 'No Market Value Transfer'
  static ERROR_LOADING_SECURITY = 'Error Loading Security Information..'
  static ERROR_LOADING_ACCOUNT = 'Error Loading Account Details..'
  static BASIS_TRANSFER_EDIT_WARNING =
    'This transaction is tied to [BASIS] through Lot Inventory by Basis. Please ensure you are loaded into the correct Basis before editing this transaction'
  static ERROR_LOADING_CALCULATED_FACTOR = 'Error Loading Calculated Factor..'
}
